"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFiRow = exports.createImageFromFrame = exports.createImageFromRawFrameInfo = exports.createImageFromFrameInfo = exports.getScale = exports.setRawFrameBasic = exports.setRawFrame = exports.setFrameBasic = exports.setFrame = exports.getRawFrame = exports.getFrame = exports.fAbi = exports.sliceOff = exports.sliceRawFrame = exports.sliceAbi = exports.slice2 = exports.slice = exports.create = void 0;
var common_sidecar_1 = require("./common-sidecar");
var frameInfo_1 = require("./frameInfo");
var preloader_sidecar_1 = require("./preloader-sidecar");
var frameSets = [];
function create() {
    // let num = 17
    // let scene = common.getScene()
    var sources = preloader_sidecar_1.preloader.spriteMapSources;
    frameSets.push([]); // frames index 0 ...
    frameSets.push([]); // 1
    // frameSets.push(slice(sources[1 - 1], 17, 32 + 1))
    frameSets.push(slice(sources[2 - 1], 45, 20 - 1));
    frameSets.push(slice(sources[3 - 1], 22, 20 - 2));
    frameSets.push(slice(sources[4 - 1], 22, 20 - 2));
    frameSets.push(slice(sources[5 - 1], 22, 20 - 2));
    frameSets.push([]);
    frameSets.push([]);
    // frameSets.push(slice2(sources[6 - 1], 24 + 1, 15 + 2)) // 6
    // frameSets.push(slice2(sources[7 - 1], 23 + 1, 16 + 2)) // 7
    frameSets.push(slice2(sources[8 - 1], 38 + 1, 8 + 2));
    frameSets.push(sliceAbi(sources[9 - 1], 6 + 2 + 1));
    frameSets.push(sliceAbi(sources[10 - 1], 15 + 2 + 1));
    frameSets.push(sliceAbi(sources[11 - 1], 15 + 2 + 1));
    frameSets.push(sliceAbi(sources[12 - 1], 17 + 2 + 1));
    frameSets.push(sliceAbi(sources[13 - 1], 15 + 2 + 1));
    frameSets.push(sliceAbi(sources[14 - 1], 16 + 2 + 1));
    frameSets.push(sliceAbi(sources[15 - 1], 16 + 2 + 1));
    // frameSets.push(slice2(sources[16 - 1], 14 + 3, 8 + 4 + 2))
    // frameSets.push(slice('2-16', 17, 16 + 1))
    // frameSets.push(slice('3-16', 17, 16 + 1))
    // for (let j = 0; j < num; j++) {
    //   for (let i = 0; i < num; i++) {
    //     let f = new Phaser.Textures.Frame(
    //       scene.game.textures.get('1-32'),
    //       i + j * num,
    //       0,
    //       2 + i * (33 + 3),
    //       2 + j * (33 + 3),
    //       33,
    //       33,
    //     )
    //     frames1.push(f)
    //   }
    // }
}
exports.create = create;
function slice(source, num, size) {
    var frames = [];
    var scene = common_sidecar_1.common.getPhaserScene();
    var tex = scene.game.textures.get(source);
    for (var j = 0; j < num; j++) {
        for (var i = 0; i < num; i++) {
            var f = new Phaser.Textures.Frame(tex, i + j * num, 0, 2 + i * (size + 3), 2 + j * (size + 3), size, size);
            frames.push(f);
        }
    }
    return frames;
}
exports.slice = slice;
function slice2(source, num, size) {
    var frames = [];
    var scene = common_sidecar_1.common.getPhaserScene();
    var tex = scene.game.textures.get(source);
    for (var j = 0; j < num; j++) {
        for (var i = 0; i < num; i++) {
            var f = new Phaser.Textures.Frame(tex, i + j * num, 0, 2 + i * (size + 3), 2 + j * (size + 3), size, size);
            frames.push(f);
        }
    }
    return frames;
}
exports.slice2 = slice2;
function sliceAbi(source, height) {
    var frames = [];
    var scene = common_sidecar_1.common.getPhaserScene();
    var size = height - 2 - 1;
    var tex = scene.game.textures.get(source);
    var texHeight = tex.get(tex.firstFrame).height;
    var texWidth = tex.get(tex.firstFrame).width;
    var num = Math.ceil(texHeight / height);
    // console.log('abi text height', texHeight, num, size, height)
    for (var j = 0; j < num; j++) {
        var f = new Phaser.Textures.Frame(tex, j * num, 0, 1, 1 + j * height, texWidth - 2, size);
        frames.push(f);
    }
    return frames;
}
exports.sliceAbi = sliceAbi;
function sliceRawFrame(source, x, y, w, h) {
    var scene = common_sidecar_1.common.getPhaserScene();
    var f = new Phaser.Textures.Frame(scene.game.textures.get(source), "sr-" + y + "-" + x + "-" + h + "-" + w, 0, x, y, w, h);
    return f;
}
exports.sliceRawFrame = sliceRawFrame;
function sliceOff(source, size, y, x, h, w) {
    // let frames: Phaser.Textures.Frame[] = []
    var scene = common_sidecar_1.common.getPhaserScene();
    var f = new Phaser.Textures.Frame(scene.game.textures.get(source), "s-" + y + "-" + x + "-" + h + "-" + w, 0, 2 + x * (size + 3), 2 + y * (size + 3), (size + 3) * w - 2, (size + 3) * h - 2);
    // frames.push(f)
    return f;
}
exports.sliceOff = sliceOff;
function f32(i, y, x) {
    var num = 17;
    if (i === 1) {
        // num = 45
        throw new Error("loading from old sprite " + i + " " + y + " " + x);
    }
    if (i === 2) {
        num = 45;
    }
    if (i === 3) {
        num = 22;
    }
    if (i === 5) {
        num = 22;
    }
    if (i === 6) {
        // num = 25
        throw new Error("loading from old sprite " + i + " " + y + " " + x);
    }
    if (i === 7) {
        // num = 24
        throw new Error("loading from old sprite " + i + " " + y + " " + x);
    }
    if (i === 8) {
        num = 39;
    }
    if (i === 9) {
        num = 42;
    }
    return frameSets[i][x + y * num];
}
function fAbi(i, y) {
    return frameSets[i][y];
}
exports.fAbi = fAbi;
function getFrame(frameInfo) {
    var frame = frameInfo.frame;
    if (!frame) {
        if ((!frameInfo.w || frameInfo.w === 1) &&
            (!frameInfo.h || frameInfo.h === 1)) {
            frameInfo.frame = f32(frameInfo.i, frameInfo.y, frameInfo.x);
        }
        else {
            // console.log('Slicing!!!')
            var sources = preloader_sidecar_1.preloader.spriteMapSources;
            var source = sources[frameInfo.i - 1];
            frameInfo.frame = sliceOff(source, 32 + 1, frameInfo.y, frameInfo.x, frameInfo.h || 1, frameInfo.w || 1);
        }
        frame = frameInfo.frame;
    }
    return frame;
}
exports.getFrame = getFrame;
function getRawFrame(rawFrameInfo) {
    var frame = rawFrameInfo.frame;
    if (!frame) {
        var sources = preloader_sidecar_1.preloader.spriteMapSources;
        var source = sources[rawFrameInfo.i - 1];
        rawFrameInfo.frame = sliceRawFrame(source, rawFrameInfo.x, rawFrameInfo.y, rawFrameInfo.w, rawFrameInfo.h);
        frame = rawFrameInfo.frame;
    }
    return frame;
}
exports.getRawFrame = getRawFrame;
function setFrame(image, frameInfo, anchorX, anchorY) {
    if (anchorX === void 0) { anchorX = 0.5; }
    if (anchorY === void 0) { anchorY = 0.5; }
    var frame = getFrame(frameInfo);
    image.frame = frame;
    image.setScale(getScale(frameInfo));
    image.setDisplayOrigin(frame.width * anchorX, frame.height * anchorY);
}
exports.setFrame = setFrame;
function setFrameBasic(image, frameInfo) {
    var frame = getFrame(frameInfo);
    image.frame = frame;
}
exports.setFrameBasic = setFrameBasic;
function setRawFrame(image, frameInfo, anchorX, anchorY) {
    if (anchorX === void 0) { anchorX = 0.5; }
    if (anchorY === void 0) { anchorY = 0.5; }
    var frame = getRawFrame(frameInfo);
    image.frame = frame;
    image.setScale(getScale(frameInfo));
    image.setDisplayOrigin(frame.width * anchorX, frame.height * anchorY);
}
exports.setRawFrame = setRawFrame;
function setRawFrameBasic(image, frameInfo, anchorX, anchorY) {
    if (anchorX === void 0) { anchorX = 0.5; }
    if (anchorY === void 0) { anchorY = 0.5; }
    var frame = getRawFrame(frameInfo);
    image.frame = frame;
    // image.setScale(getScale(frameInfo))
    image.setDisplayOrigin(frame.width * anchorX, frame.height * anchorY);
}
exports.setRawFrameBasic = setRawFrameBasic;
function getScale(frameInfo) {
    var scale = frameInfo.scale || 1;
    scale *= 4;
    return scale;
}
exports.getScale = getScale;
function createImageFromFrameInfo(layer, frameInfo, x, y, scale) {
    return createImageFromFrame(layer, getFrame(frameInfo), x || 0, y || 0, scale !== null && scale !== void 0 ? scale : getScale(frameInfo));
}
exports.createImageFromFrameInfo = createImageFromFrameInfo;
function createImageFromRawFrameInfo(layer, rawFrameInfo, x, y, scale) {
    return createImageFromFrame(layer, getRawFrame(rawFrameInfo), x, y, scale !== null && scale !== void 0 ? scale : getScale(rawFrameInfo));
}
exports.createImageFromRawFrameInfo = createImageFromRawFrameInfo;
function createImageFromFrame(layer, frame, x, y, scale) {
    if (scale === void 0) { scale = 1; }
    var scene = common_sidecar_1.common.getPhaserScene();
    var image = scene.add.image(0, 0, '');
    layer.add(image);
    image.width = frame.width;
    image.height = frame.height;
    image.frame = frame;
    image.originX = 0.5;
    image.originY = 0.5;
    image.x = x;
    image.y = y;
    if (scale) {
        image.setScale(scale);
    }
    image.setDisplayOrigin(frame.width / 2, frame.height / 2);
    return image;
}
exports.createImageFromFrame = createImageFromFrame;
var createFiRow = function (i, y, x, w) {
    var fis = [];
    for (var idx = 0; idx < w; idx++) {
        fis.push(frameInfo_1.fi32(i, y, x + idx));
    }
    return fis;
};
exports.createFiRow = createFiRow;
